var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"currency-card--container",on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-img',{attrs:{"src":_vm.image,"height":"72px","width":"72px"}}),_c('p',{staticClass:"currency-card--title"},[_vm._v(_vm._s(_vm.currency))]),_c('span',{staticClass:"currency-card--description"},[_vm._v(_vm._s(_vm.description))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }